import { themeVars } from '@styles/themes.css';
import { style } from '@vanilla-extract/css';

export const field = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  width: '100%',
});

export const inputWrap = style({
  position: 'relative',
  width: '100%',
});

export const required = style({
  color: themeVars.color.error,
  marginLeft: '0.25rem',
});

export const input = style({
  width: '100%',
  height: '2.5rem',
  boxSizing: 'border-box',
  border: 'none',
  borderBottom: `1px solid ${themeVars.color.interactive.inputBorder}`,
  background: themeVars.color.interactive.inputBackground,
  padding: '0.5rem 1.5rem 0.5rem 0.125rem',
  font: 'inherit',
  outline: 'none',
  selectors: {
    '&:focus-visible': {
      borderBottomColor: themeVars.color.interactive.ring,
    },
  },
});

export const inputError = style({
  borderBottomColor: themeVars.color.error,
});

export const validationIcon = style({
  position: 'absolute',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
  display: 'flex',
});

export const error = style({
  color: themeVars.color.error,
});
